import React from 'react';
import { Grid, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { listStyles } from './section-list-with-search-field-component-helper';

interface SectionListEmptyErrorProps {
    emptyErrorHeadingText: string;
    emptyErrorSubHeadingText: string;
}

export const SectionListEmptyError = ({
    emptyErrorHeadingText,
    emptyErrorSubHeadingText,
}: SectionListEmptyErrorProps): React.JSX.Element => {
    return (
        <Grid sx={listStyles.emptyContainerStyles}>
            <ErrorOutlineIcon sx={listStyles.errorIconStyles} />
            <Typography sx={listStyles.errorHeaderTextStyles}>
                {emptyErrorHeadingText}
            </Typography>
            <Typography sx={listStyles.textStyles}>
                {emptyErrorSubHeadingText}
            </Typography>
        </Grid>
    );
};
